export function Logo() {
    return (
        <span className="inline-block h-9 w-9">
            <svg viewBox="0 0 36 36" width="36" height="36" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18" cy="18" r="16" fill="#fff" stroke="#d32f2f" strokeWidth="4" />
                <circle cx="18" cy="18" r="10" fill="#fff" stroke="#d32f2f" strokeWidth="4" />
                <circle cx="18" cy="18" r="5" fill="#000" />
            </svg>
        </span>
    );
}
